// extracted by mini-css-extract-plugin
module.exports = {"editUserSettingsWindow":"editUserSettingsWindow__neJ2Z","messageGroup":"messageGroup__5+Gup"};